// Auto-refactored from translations.js on 2026-08-19
// Locale: hi

const hi = {
  wieMoeglich: { question: 'यह कैसे संभव है?', answer: 'हमने वैल्यू चेन को नए सिरे से सोचा है।' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'STIG ROCK का मार्ग',
    fazit: 'छोटी आपूर्ति श्रृंखला से सबसे बड़ी लागत मदें समाप्त हो जाती हैं।',
    fazitBigPre: 'इससे संभव छूट अधिकतम',
    fazitBigValue: '80%',
    steps: [ 'खदान', 'कटाई कार्यशाला', 'प्रमाणन', 'अंतिम ग्राहक' ]
  },
  nav: { language: 'भाषा', contact: 'संपर्क' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'एक अद्वितीय अवसर',
    subtitle: 'भविष्य-उन्मुख संपत्ति का निर्माण करें।',
    description: 'STIG ROCK एक अंतर्राष्ट्रीय प्लेटफ़ॉर्म है जो लोगों को प्राकृतिक हीरों, सतत संपत्ति निर्माण और एक अनूठे समुदाय तक पहुंच प्रदान करता है।',
    scroll: 'खोजने के लिए स्क्रॉल करें'
  },
  disclaimer: {
    overline: 'कानूनी सूचना',
    title: 'Disclaimer',
    paragraphs: [
      'यह प्रस्तुति केवल सूचना के उद्देश्य से है और इसमें कोई वित्तीय, निवेश या कर सलाह शामिल नहीं है।',
      'STIG ROCK कोई वित्तीय उत्पाद नहीं है, बल्कि मूर्त संपत्ति के रूप में प्राकृतिक Diamond से संबंधित है।',
      'मूल्य विकास, लाभ या आय की कोई गारंटी नहीं दी जाती है। पिछला प्रदर्शन भविष्य के परिणामों का संकेत नहीं है।',
      'कमीशन के संबंध में दिखाए गए सभी कैलकुलेशन केवल उदाहरण के लिए हैं और ये भी कोई गारंटी नहीं देते हैं।'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'संरचना पर', 'निर्मित' ],
    body: 'STIG Group एक अंतरराष्ट्रीय समूह है, जो स्पष्टता, जिम्मेदारी और दीर्घकालिक मूल्य पर आधारित है। हर ब्रांड, हर परियोजना और हर साझेदारी एक ही मानक का पालन करती है — बिना किसी शॉर्टकट के, बिना किसी अपवाद के।',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'संरचना पर', 'निर्मित' ],
        body: 'STIG Group एक अंतरराष्ट्रीय समूह है, जो स्पष्टता, जिम्मेदारी और दीर्घकालिक मूल्य पर आधारित है। हर ब्रांड, हर परियोजना और हर साझेदारी एक ही मानक का पालन करती है — बिना किसी शॉर्टकट के, बिना किसी अपवाद के।'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'विशिष्ट Diamond', 'की दुनिया' ],
        body: 'STIG ROCK, STIG Group की एक आधुनिक अवधारणा है, जो पारदर्शी संरचनाओं और एक विशिष्ट ग्राहक अनुभव के साथ उच्च गुणवत्ता वाले GIA-प्रमाणित Diamond को जोड़ती है। स्पष्ट समाधान योजनाएं, पेशेवर निष्पादन और अंतरराष्ट्रीय दृष्टिकोण।'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'अंतरराष्ट्रीय', 'Diamond व्यापार' ],
        body: 'Stig International, STIG Group का हिस्सा है और GIA-प्रमाणित Diamond के अंतरराष्ट्रीय व्यापार में माहिर है। वैश्विक साझेदारियों के साथ गुणवत्ता, भरोसे और आधुनिक व्यापार संरचनाओं पर ध्यान केंद्रित।'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'खदान से ही', 'जिम्मेदारी' ],
        body: 'Ethical Mines जिम्मेदार खनन, पता लगाने योग्य मूल और संघर्ष-मुक्त Diamond का प्रतीक है। खदान से बाजार तक — पारदर्शिता, अखंडता और पूरी आपूर्ति श्रृंखला में दीर्घकालिक जिम्मेदारी के लिए पूर्ण दस्तावेज।'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'हीरे',
    stigDrawback: 'वास्तविक मूल्य भंडार',
    overline: 'संभावनाएं',
    title: 'संपत्ति निर्माण के अवसर',
    subtitle: 'पारंपरिक तरीकों की तुलना।',
    items: [
      {
        tag: 'Trading',
        name: 'Forex या Krypto',
        drawback: 'अत्यधिक सट्टा, अप्रत्याशित, जटिल'
      },
      {
        tag: 'Aktien',
        name: 'शेयर बाजार',
        drawback: 'उतार-चढ़ाव का जोखिम, ज्ञान की आवश्यकता, समय की खपत'
      },
      {
        tag: 'Krypto',
        name: 'व्यापार',
        drawback: 'अस्थिरता, नियामक जोखिम, सुरक्षा कमियां'
      }
    ]
  },
  chance: {
    overline: 'Diamanten',
    title: 'एक कम आंका गया अवसर',
    body: 'Diamond वर्षों से सबसे स्थिर और अवसरवादी निवेश रूपों में से एक रहे हैं, लेकिन अब तक बहुत कम लोगों ने इस क्षमता का उपयोग किया है।',
    callout: 'हमारे STIG ROCK के साथ, हम पहली बार सभी के लिए इन असाधारण संभावनाओं के द्वार खोल रहे हैं।'
  },
  wertentwicklung: {
    overline: 'मूल्य विकास 1995 — 2025',
    title: 'मूल्य की एक कहानी।',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: '1995 — 2025 से विकास'
  },
  hauptgruende: {
    overline: 'मुख्य कारण',
    title: 'Diamond के छह कारण',
    lead: 'Diamond वास्तविक मूर्त संपत्ति हैं जो मुद्राओं और वित्तीय प्रणालियों से स्वतंत्र रूप से मौजूद हैं — और सदियों से अपना मूल्य बनाए रखा है।',
    items: [
      {
        n: '01',
        title: 'संकट-सुरक्षित मूल्य स्थिरता',
        body: 'मूर्त संपत्ति की गारंटी। मुद्राओं और वित्तीय प्रणालियों से स्वतंत्र।'
      },
      {
        n: '02',
        title: 'परम गतिशीलता',
        body: 'छोटा, छिपाने में आसान और ले जाने में सुगम।'
      },
      { n: '03', title: 'विविधीकरण और कमी', body: 'आपूर्ति की कमी और प्राकृतिक सीमा।' },
      { n: '04', title: 'दीर्घकालिक विकास', body: '1995 से +185%।' },
      {
        n: '05',
        title: 'पारदर्शिता और विशिष्टता',
        body: 'गारंटी के रूप में 4 Cʼs: Carat, Color, Clarity, Cut।'
      },
      {
        n: '06',
        title: 'राजघरानों का रिजर्व',
        body: 'यहाँ तक कि राजघराने भी Diamond को संपत्ति रिजर्व के रूप में उपयोग करते हैं।'
      }
    ]
  },
  markt: {
    overline: 'बाजार की मात्रा',
    title: '99 — 108 Mrd. USD',
    sub: 'वर्ष 2025 में व्यापार की मात्रा',
    forecast: '~2032 / 2034 तक पूर्वानुमान: मध्यम विकास (~4 – 5 % p.a.) पर लगभग 140 – 168 Mrd. USD।',
    source: 'स्रोत: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — नवाचार',
    title: 'एक नवाचार। दुनिया में पहली बार।',
    body: 'STIG ROCK दुनिया का पहला ऐसा प्लेटफॉर्म है जो लोगों को मूल्य वृद्धि के साथ-साथ Diamond बाजार में निष्क्रिय आय प्राप्त करने में सक्षम बनाता है।',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'रजिस्टर नं. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'कंपनी के बारे में',
    titleLines: [ 'अंतरराष्ट्रीय', 'संरचना', 'स्पष्ट दृष्टि' ],
    body: 'STIG ROCK की स्थापना Diamond बाजार को अधिक पारदर्शी, आधुनिक और ग्राहक-केंद्रित बनाने के लिए की गई थी — जिसमें भरोसे, सुरक्षा और दीर्घकालिक संरचना पर ध्यान केंद्रित किया गया है।'
  },
  sicherheit: {
    overline: 'गुणवत्ता और सुरक्षा',
    title: 'Gemological Institute of America',
    body: 'आपके Diamond के लिए प्रमाणित विशेषज्ञता। GIA उच्चतम सटीकता और वर्षों के अनुभव के साथ प्रत्येक पत्थर का मूल्यांकन करते हैं — हमारी कंपनी और हमारे ग्राहकों के लिए विश्वसनीय मूल्य रिपोर्ट।',
    transparency: 'प्रत्येक Diamond उच्चतम गुणवत्ता मानकों को पूरा करता है और प्रसिद्ध संगठनों द्वारा परीक्षित और प्रमाणित है। प्रत्येक पत्थर अद्वितीय है और उसे एक व्यक्तिगत प्रमाणपत्र मिलता है।'
  },
  plaene: {
    overline: 'Solution Plan (SP)',
    title: 'एक अद्वितीय उत्पाद नवाचार',
    sub: 'छह स्तरीय Solution Plan — $1K से $100K+ तक, प्रत्येक में प्रति माह और पूरी अवधि के दौरान बढ़ती छूट के साथ।',
    recommended: 'लोकप्रिय',
    oneYear: '1 साल',
    rowLabels: {
      delivery: 'वितरण का समय',
      price: 'उत्पाद की कीमत',
      carat: 'Carat',
      monthly: 'छूट (मासिक)',
      totalDiscount: 'छूट (कुल)',
      duration: 'अवधि'
    },
    headers: {
      plan: 'Plan',
      from: 'से',
      carat: 'Carat',
      monthly: 'छूट / माह',
      total: 'कुल छूट',
      duration: 'अवधि'
    },
    duration: '1 साल',
    footnote: 'सभी मूल्य जानकारी बिना किसी वारंटी के हैं और गुणवत्ता, मांग और वर्तमान बाजार विकास पर निर्भर करती हैं। Solution Plan 2 साल के लिए भी संभव हैं।'
  },
  plaeneVIP: {
    overline: 'Solution Plan + VIP-पैकेज',
    title: 'VIP-Paket के साथ अधिक लाभ',
    sub: 'अपनी Solution Plan को VIP-Paket के साथ जोड़ें और 3% तक के अतिरिक्त मूल्य लाभों का आनंद लें। इस प्रकार आप अपनी कुल छूट बढ़ाएं और और भी आकर्षक शर्तें सुरक्षित करें।',
    rowLabels: {
      delivery: 'वितरण का समय',
      price: 'उत्पाद की कीमत',
      carat: 'Carat',
      monthly: 'छूट (मासिक)',
      totalDiscount: 'छूट (कुल)',
      vip1: 'VIP-पैकेज 1 (+1%)',
      vip2: 'VIP-पैकेज 2 (+2%)',
      vip3: 'VIP-पैकेज 3 (+3%)'
    },
    footnote: 'सभी मूल्य जानकारी बिना किसी वारंटी के हैं और गुणवत्ता, मांग और वर्तमान बाजार विकास पर निर्भर करती हैं।'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'VIP-Paket के साथ अधिक लाभ',
    sub: 'अपनी Solution Plan को VIP-Paket के साथ जोड़ें और 3% तक के अतिरिक्त मूल्य लाभों का आनंद लें। इस प्रकार आप अपनी कुल छूट बढ़ाएं और और भी आकर्षक शर्तें सुरक्षित करें।',
    options: [
      {
        key: 'deliver',
        title: 'VIP-Paket के साथ अधिक लाभ',
        body: 'आपके DS-Plan* की कीमत पर Diamond (Carat)'
      },
      {
        key: 'sellToUs',
        title: 'हमें बेचें',
        body: 'आप अपने Diamond हमें आपके द्वारा भुगतान की गई खरीद मूल्य पर वापस बेच सकते हैं।'
      },
      {
        key: 'sellThirdParty',
        title: 'तीसरे पक्ष को बेचें',
        body: 'आप अपने Diamond किसी तीसरे पक्ष को बेच सकते हैं।'
      }
    ],
    footnote: '*DS-Plan का अर्थ Solution Plan है।'
  },
  tradWeg: {
    overline: 'पारंपरिक व्यापार',
    title: 'पारंपरिक तरीका',
    sub: 'Diamond अंतिम ग्राहक तक पहुँचने से पहले, खदान से कच्चे Diamond की कीमत की तुलना में बिचौलियों, थोक और खुदरा व्यापार के कारण काफी मार्जिन बन जाता है।',
    steps: [
      { title: 'खदान', subtitle: 'कच्चे Diamond' },
      { title: 'बिचौलिया', subtitle: 'कच्चे Diamond की खरीद' },
      { title: 'पॉलिशिंग', subtitle: 'जेवर Diamond में कटाई' },
      { title: 'प्रमाणन', subtitle: 'GIA जैसे मान्यता प्राप्त संस्थानों द्वारा' },
      { title: 'Diamond एक्सचेंज', subtitle: 'थोक विक्रेताओं को बिक्री' },
      { title: 'थोक व्यापार', subtitle: 'खुदरा विक्रेताओं को बिक्री' },
      { title: 'खुदरा व्यापार', subtitle: 'जैसे कि जौहरी' },
      { title: 'अंतिम ग्राहक', subtitle: 'Diamond की खरीद' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-पैकेज',
    sub: 'आपके द्वारा लिए गए सभी Solution Plan पर 12 महीनों के लिए वैध। VIP-पैकेज के अनुसार: +1% से +3% अतिरिक्त छूट',
    cardKicker: 'अतिरिक्त – सभी',
    cardKicker2: 'Solution Plan पर',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'छूट से बचत',
      body: 'मासिक खर्च के बजाय मासिक बचत। छूट से बचत होती है — और यही बचत उन चीजों का भुगतान करती है जिनके लिए आप आमतौर पर हर महीने अपनी जेब से भुगतान करते हैं।',
      line1Label: 'DS-Plan से',
      line1Value: '$5.000',
      line2Label: 'मासिक छूट',
      line2Value: '3%',
      line3Label: 'VIP-पैकेज 3',
      line3Value: '+3%',
      resultLabel: 'मासिक बचत',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'यह कैसे संभव है?',
    title: 'हमने मूल्य श्रृंखला को नए सिरे से सोचा है।',
    traditionalTitle: 'पारंपरिक तरीका',
    traditionalSteps: [
      'खदान — कच्चे Diamond',
      'बिचौलिया — खरीद',
      'पॉलिशिंग — कटाई',
      'प्रमाणन (GIA)',
      'Diamond एक्सचेंज — थोक व्यापार',
      'थोक व्यापार → खुदरा व्यापार',
      'जौहरी → अंतिम ग्राहक'
    ],
    traditionalNote: 'Diamond अंतिम ग्राहक तक पहुँचने से पहले, बिचौलियों, थोक और खुदरा व्यापार के कारण भारी मार्जिन बन जाता है।',
    stigTitle: 'STIG ROCK तरीका',
    stigSteps: [
      'सीधी खरीद — खदान से कच्चे Diamond',
      'हमारे Partner द्वारा पॉलिश और प्रमाणन',
      'अंतिम ग्राहकों और B2B ग्राहकों को बिक्री',
      'साल में 4 व्यापार चक्रों तक'
    ],
    stigNote: 'हम चक्र को तोड़ते हैं और व्यापारिक मार्जिन को छूट क्रेडिट के रूप में अपने ग्राहकों को देते हैं — DS-Plan अवधि के दौरान 4 व्यापार चक्रों तक।'
  },
  optionen: {
    overline: 'आपकी संभावनाएं',
    title: 'आपके Solution Plan की समाप्ति के बाद',
    items: [
      { title: 'वितरण करवाएं', body: 'आपके DS-Plan की कीमत पर Diamond (Carat)।' },
      { title: 'हमें बेचें', body: 'आपके द्वारा भुगतान की गई खरीद मूल्य पर वापस बिक्री।' },
      { title: 'तीसरे पक्ष को बेचें', body: 'मुक्त बाजार में Diamond बेचें।' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution Plan — एक अद्वितीय उत्पाद नवाचार',
    title: 'आसान तरीका',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'पंजीकरण',
        body: 'अपने रेफ़रर से संपर्क करें और एक निःशुल्क खाता बनाएँ!'
      },
      { n: '02', icon: 'cart', title: 'उत्पाद की खरीद', body: '$ 250,- से शुरू' },
      {
        n: '03',
        icon: 'discount',
        title: 'छूट प्राप्त करें',
        body: 'मासिक छूट क्रेडिट प्राप्त करें।'
      }
    ]
  },
  business: {
    overline: 'बोनस के प्रकार',
    title: 'सबसे आसान और निष्पक्ष तरीका।',
    sub: 'पांच प्रकार के बोनस — आपके सफल व्यवसाय निर्माण के लिए।',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Level 3 तक, करियर स्तर Pearl / Ruby से।'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Sapphire से — असीमित गहराई तक।'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Infinity Bonus पर – Level 5 तक · बिना किसी योग्यता के।'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: 'वैश्विक टर्नओवर के 3 Pool।'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Diamond (Carat) में एकमुश्त बोनस।'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'यह बोनस आपको Level 3 तक प्रत्येक नए Solution Plan के लिए दिया जाता है। बहुत कम योग्यता के साथ आप अलग-अलग लेवल खोल सकते हैं।',
    total: '18% तक Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'शुरुआत से ही',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'करियर स्तर Pearl से',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'करियर स्तर Ruby से',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'करियर स्तर Sapphire से आप हमारे Infinity Bonus योजना के लिए योग्य हो जाते हैं। आपको 3% बोनस मिलता है। प्रत्येक नए करियर स्तर के साथ अतिरिक्त प्रतिशत जोड़ा जाता है। यदि आपकी टीम में कोई Partner भी योग्य है, तो आपको रैंक से रैंक के बीच का अंतर प्राप्त होता है।',
    exampleTitle: 'उदाहरण',
    exampleRows: [
      { label: 'आप Blue Diamond हैं', value: '12%' },
      { label: 'आपका Partner Sapphire है', value: '3%' }
    ],
    exampleResult: { label: 'आपका Infinity Bonus', value: '9%' },
    totalNote: 'आपकी टीम में सभी Solution Plan पर कुल 24% तक Infinity Bonus — असीमित गहराई तक।',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'इस बोनस के साथ आप अपनी टीम की सफलता से लाभान्वित होते हैं। आप अपने Partner के Infinity Bonus पर 5% का Matching Bonus प्राप्त करते हैं — और वह भी आपकी टीम के 5वें स्तर तक।',
    note: 'आपकी टीम में सभी Infinity Bonus भुगतान पर – 5वें लेवल तक। शुरुआत से ही – बिना योग्यता के।',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'कुल मिलाकर',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: 'वैश्विक टर्नओवर का 3% समान भागों में 3 अलग-अलग Pool में जाता है। कुछ करियर स्तरों तक पहुँच कर आप प्रत्येक व्यक्तिगत Pool के लिए योग्य हो जाते हैं।',
    forever: 'एक बार पहुँच गए – हमेशा के लिए भागीदार!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'Blue Diamond से' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'Purple Diamond से' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'Double Diamond Elite से' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'कुल',
    totalValue: '3%',
    totalSuffix: 'वैश्विक टर्नओवर का'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'करियर स्तर Diamond से आपको एक Rang Bonus मिलता है। यह Diamond (Carat) में भुगतान किया जाता है। यह एक एकमुश्त बोनस है।',
    highlight: 'कुल मूल्य के Diamond (Carat)',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · करियर स्तर',
    title: 'करियर स्तर',
    sub: 'संबंधित करियर स्तर प्राप्त करने के लिए ऐतिहासिक कुल टर्नओवर (HG) गिना जाता है। Sapphire स्तर से इसे कई टीमों में विभाजित किया जाना चाहिए। Ruby या उससे ऊपर पहुँचने के लिए, आपको Solution Plan के साथ कम से कम दो प्रत्यक्ष Partner की आवश्यकता है।',
    forever: 'एक बार प्राप्त किया – हमेशा के लिए पुष्ट!',
    footnote: 'HV = ऐतिहासिक कुल टर्नओवर।',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 प्रत्यक्ष Partner', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'हमारे साथ शुरुआत करें',
    title: 'सही समय अभी है।',
    body: 'यह व्यावसायिक मॉडल नए मानक स्थापित करता है और दीर्घकालिक टिकाऊ और सफल व्यवसाय के लिए सभी सफलता कारकों को जोड़ता है। आज ही पंजीकरण करें, अपना Solution Plan चुनें और इस अद्वितीय व्यावसायिक अवसर का लाभ उठाएं।',
    hint: 'उस व्यक्ति से बात करें जिसने आपको इस प्रस्तुति के लिए आमंत्रित किया है — उनके पास आपके लिए पंजीकरण लिंक है।',
    formName: 'नाम',
    formEmail: 'ई-मेल',
    formPhone: 'फोन',
    formSubmit: 'संपर्क करें',
    success: 'धन्यवाद — हम गोपनीय और व्यक्तिगत रूप से आपसे संपर्क करेंगे।',
    callCta: 'कॉल करें',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'कानूनी सूचना और Disclaimer',
    disclaimer: 'यह प्रस्तुति केवल सूचना के लिए है और इसमें कोई वित्तीय, निवेश या कर सलाह शामिल नहीं है। STIG ROCK कोई वित्तीय उत्पाद नहीं है, बल्कि मूर्त संपत्ति के रूप में प्राकृतिक Diamond से संबंधित है। मूल्य विकास, लाभ या आय की कोई गारंटी नहीं दी जाती है। पिछला प्रदर्शन भविष्य के परिणामों का संकेत नहीं है। कमीशन के संबंध में दिखाए गए सभी कैलकुलेशन केवल उदाहरण के लिए हैं और ये भी कोई गारंटी नहीं देते हैं। सामग्री में परिवर्तन के अधीन — स्वतंत्र अनुवाद (कोई आधिकारिक अनुवाद नहीं)।',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. सर्वाधिकार सुरक्षित।',
    version: 'संस्करण: DS-12-2025 V3'
  },
  misc: { next: 'अगला भाग' }
};

export default hi;
